import {learnerPageCount} from './learning-page-progress';
/** An issued item may contain several presentation pages. Completion is last-page only. */
export function presentationCanComplete(item:any,navigation:any){
 const total=learnerPageCount(item);
 return total===1||Boolean(navigation&&navigation.progressTotal===total&&navigation.progressIndex===total&&!navigation.hasNext&&navigation.finalPage!==false);
}
